window.SiteReady(($) => {

  console.log('Init Block: Testimonials - Video Slider');

  $('.block_testimonials_video_slider').each((blockIndex, block) => {
    const $block = $(block);
    const $splide = $block.find('.js-testimonials_video_slider');
    const $current = $block.find('.js-testimonials_video_slider_current');
    const $total = $block.find('.js-testimonials_video_slider_total');

    if (!$splide.length || !$current.length || typeof $splide.splide !== 'function') {
      return;
    }

    // Options from the markup; `type` is injected per viewport below.
    const baseOptions = $.extend({}, $splide.data('splide-options') || {});
    const mediaQueryKey = 'testimonials-video-slider-' + ($block.attr('id') || blockIndex);

    const getInstance = () => {
      const data = $splide.data('splide-data');
      return data && data.Splide ? data.Splide : null;
    };

    const bindInstance = (splide) => {
      const updateCounter = () => {
        $current.text(splide.index + 1);

        if ($total.length) {
          $total.text(splide.length);
        }
      };

      splide.on('mounted move moved refresh updated', updateCounter);
      updateCounter();
    };

    const mount = (type, startIndex) => {
      // Feed the shared plugin the desired type, then let it build + mount.
      $splide.data('splide-options', $.extend({}, baseOptions, {
        type: type,
        start: startIndex || 0,
      }));

      $splide.splide();

      const whenReady = () => {
        const splide = getInstance();

        if (!splide) {
          window.requestAnimationFrame(whenReady);
          return;
        }

        bindInstance(splide);
      };

      whenReady();
    };

    const remount = (type) => {
      const splide = getInstance();
      const startIndex = splide ? splide.index : 0;

      if (splide) {
        splide.destroy(true);
        $splide.removeData('splide-data');
      }

      mount(type, startIndex);
    };

    // Swap the transition when crossing the desktop breakpoint. bind() also
    // fires the matching side immediately, so this covers the initial mount
    // too — no separate bootstrap call needed.
    $.mediaquery('bind', mediaQueryKey, '(min-width: 980px)', {
      enter: () => remount('fade'),
      leave: () => remount('slide'),
    });
  });

});
